import { AdditionalColors } from '@gc-bridge/theme/colors';
import { Box, styled } from '@mui/material';

export const GcBridgeBottom = styled(Box)(() => ({
  backgroundColor: AdditionalColors.NavyBlue,
  height: '250px',
  width: '100%',
}));
